/**
 * layoutVisorXml.js
 *
 * Orden, encabezado y tipo de celda de las 27 columnas de la hoja "VISOR XML":
 * un renglón por CFDI de nómina timbrado.
 *
 * `clave` es la propiedad del renglón que devuelve
 * `erp_backend/Controllers/reportesNomina.controllers.js -> reporteXmlEmitidos`.
 *
 * Una diferencia a propósito contra el archivo del cliente: allá la columna del
 * periodo se llama "▲ Período". El triangulito es el indicador de orden del
 * visor que lo exportó, no parte del formato, así que aquí va sin él.
 */

export const COLUMNAS_VISOR = [
  { columna: "Registro Patronal", clave: "registroPatronal", tipo: "centro" },
  { columna: "Fecha Comprobante", clave: "fechaComprobante", tipo: "centro" },
  { columna: "Tipo Periodo", clave: "tipoPeriodo", tipo: "centro" },
  { columna: "Ejercicio", clave: "ejercicio", tipo: "numero" },
  { columna: "Período", clave: "periodo", tipo: "numero" },
  { columna: "Inicio Período", clave: "inicioPeriodo", tipo: "centro" },
  { columna: "Fin Período", clave: "finPeriodo", tipo: "centro" },
  { columna: "Departamento", clave: "departamento", tipo: "texto" },
  { columna: "Código Empleado", clave: "codigoEmpleado", tipo: "centro" },
  { columna: "Nombre Receptor", clave: "nombreReceptor", tipo: "texto" },
  { columna: "APELLIDO PAT", clave: "apellidoPaterno", tipo: "texto" },
  { columna: "APELLIDO MAT", clave: "apellidoMaterno", tipo: "texto" },
  { columna: "NOMBRES", clave: "nombres", tipo: "texto" },
  { columna: "Núm. Seguridad Social", clave: "numSeguridadSocial", tipo: "centro" },
  { columna: "RFC Receptor", clave: "rfc", tipo: "centro" },
  { columna: "CURP", clave: "curp", tipo: "centro" },
  { columna: "PUESTO", clave: "puesto", tipo: "texto" },
  { columna: "TIPO PERSONAL", clave: "tipoPersonal", tipo: "centro" },
  { columna: "SBC", clave: "sbc", tipo: "moneda" },
  { columna: "FECHA INGRESO", clave: "fechaIngreso", tipo: "centro" },
  { columna: "FECHA DE REINGRESO", clave: "fechaReingreso", tipo: "centro" },
  { columna: "Fecha Pago", clave: "fechaPago", tipo: "centro" },
  { columna: "Total", clave: "total", tipo: "moneda" },
  { columna: "Neto", clave: "neto", tipo: "moneda" },
  { columna: "Estatus", clave: "estatus", tipo: "centro" },
  { columna: "UUID", clave: "uuid", tipo: "centro" },
  { columna: "Observaciones", clave: "observaciones", tipo: "texto" },
];

export const HEADERS_VISOR = COLUMNAS_VISOR.map((c) => c.columna);

// Índices de las dos columnas que llevan total al pie de la hoja.
export const INDICE_TOTAL = COLUMNAS_VISOR.findIndex((c) => c.clave === "total");
export const INDICE_NETO = COLUMNAS_VISOR.findIndex((c) => c.clave === "neto");

export const ANCHOS_VISOR = [
  16, 18, 12, 10, 10, 14, 14, 22, 14, 34, 20, 20, 24, 20, 16, 20, 18, 14, 12,
  14, 18, 14, 14, 14, 12, 38, 24,
];
